module.exports = __webpack_public_path__ + "media/images/80stees-logo-w-com-63d73eb779c211a81eef819762be4363.png";